var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterArt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 160,
    className: "footer-image",
    viewBox: "0 0 1200 160",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0c4499}.cls-3{fill:#f2af34}.cls-4{fill:#136ffb}.cls-5{fill:#c1edfe}.cls-6{fill:#fff}.cls-7{fill:#bfecff}.cls-9{fill:#c1e8fa}.cls-10{fill:#194995}.cls-11{fill:#c0e7fa}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98 143c4-3 9 7 9 7s-7-15 0-16c2 0 5 6 6 13 0-6 2-11 4-11 6-1 2 15 2 15l-1 9h-10s-14-14-10-17z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M815 151h1a20 20 0 0 0 6-11c2-4 2-9-1-14-7-13-23-6-29 1a16 16 0 0 0-3 15 19 19 0 0 0 14 12 17 17 0 0 0 12-3z",
    style: {
      fill: "#fed036"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M806 131h1v29h-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M508 149c-1-1-4-1-5 1a7 7 0 0 0-1 3c0-3-1-12-5-12-3 0-3 8-3 12-2-4-3-6-5-6-6 0 1 13 1 13h14l2-3a19 19 0 0 0 2-4 5 5 0 0 0 0-2 3 3 0 0 0 0-2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M256 142c2 0 4 5 5 11 0-5 2-9 3-10 6 0 3 9 3 9l-2 8h-8s-7-17-1-18zm579 0c2 0 4 5 5 11 0-5 2-9 3-10 6 0 3 9 3 9l-2 8h-8s-7-17-1-18zm-147-4c1-6-3-33-15-29-3 2-7 8-8 11-5 9-7 27 2 34 5 3 12 2 16-2 4-3 5-8 5-14z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M674 126h1v34h-1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1141 143c0-4-3-7-3-10l-2-10c-2-2-3-3-6-3s-4 1-6 3l-1 10-4 10c-2 7 2 13 9 13h3a11 11 0 0 0 11-13h-1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1130 133h1v27h-1zM199 54l-38 63h77l-39-63z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149 55h51v62h-51z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m149 54-38 63h77l-39-63z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m149 61-34 56h69l-35-56zm-34 56h69v21h-69z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M165 117h69v21h-69z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M130 122h14v10h-14zm81 0h14v10h-14z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M115 138h119v22H115z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146 138h55v22h-55z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m178 101-22 37h45l-23-37z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M168 101h10v9h-10z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m168 101-22 37h45l-23-37z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m168 110-13 22h27l-14-22z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M121 141h21v13h-21zm88 0h20v13h-20z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146 137h45v23h-45z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M168 138a7 7 0 0 1 8 7v15h-15v-15a7 7 0 0 1 7-7z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M144 89h11v17h-11z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M858 9h93v151h-93z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M951 9h23v151h-23z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M868 19h13v26h-13zm26 0h14v26h-14zm-26 33h13v27h-13zm26 0h14v27h-14zm-26 33h13v26h-13zm26 0h14v26h-14zm30-66h14v26h-14zm0 33h14v27h-14zm0 33h14v26h-14z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M883 144h32v16h-32z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M904 127c6 0 11 6 11 13v4h-30v-17z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M885 127a13 13 0 0 0-12 13v4h25v-4a13 13 0 0 0-13-13zM848 0h103v9H848z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M951 0h23v9h-23z",
    style: {
      fill: "#006aff"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1014 87h59v73h-59z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1073 87h27v73h-27z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1082 118h32v42h-32z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1114 118h12v42h-12z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1024 98h40v17h-40z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1032 98h24v17h-24zm64 32h18v23h-18z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1114 130h8v23h-8z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1024 137h13v17h-13z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1024 154h13v6h-13z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1045 133h19v27h-19z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1049 137h15v23h-15zm-39-14h50v4h-50zm0-38h63v3h-63z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1073 85h29v3h-29z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1059 123h7v4h-7z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1083 113h1v5h-1zm4 0h1v5h-1zm3 0h1v5h-1zm3 0h1v5h-1zm3 0h1v5h-1zm3 0h1v5h-1zm3 0h1v5h-1zm4 0h1v5h-1zm3 0h1v5h-1zm3 0h1v5h-1z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1115 113h1v5h-1zm4 0h1v5h-1zm3 0h1v5h-1z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1082 111h32v2h-32z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1114 111h12v2h-12z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M686 123h98v33h-98z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M797 123H686l3-41h105l3 41z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m736 85 24 28h-48l24-28z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M763 115h-54l27-33zm-47-3h40l-20-25z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M733 96h7v10h-7zm-31 32h20v19h-20zm61 5h16v14h-16z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M741 134h11v22h-11z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M767 76h12v22h-12z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M711 126h2v23h-2z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M701 138v-2h23v2z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M736 120h50v4h-50z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M737 121v35h-3v-35zm21-1v36h-3v-36zm28 1v35h-3v-35z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m713 93 24 28h-48l24-28z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M740 123h-55l28-33zm-47-3h40l-20-24z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M709 104h8v12h-8z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M786 120h11v36h-11z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M788 134h6v12h-6z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M686 156h111v4H686z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M505 72h103v88H505z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M505 146h103v1H505zm0-6h103v1H505zm0-6h103-103zm0-7h103v1H505zm0-6h103v1H505zm0-6h103v1H505zm0-6h103-103zm0-7h103v1H505zm0-6h103v1H505zm0-6h103v1H505zm0-7h103v1H505zm0-6h103v1H505zm111 29h23v54h-23z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M505 72h38v37h-38z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M497 103h46v7h-46z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M526 127h17v29h-17z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M547 130h8v7h-8zm13 0h8v7h-8zm23-44h7v8h-7zm13 0h8v8h-8zm-74 40h21v4h-21z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M616 154h23v1h-23zm0-6h23v1h-23zm0-7h23v1h-23zm0-6h23v1h-23zm0-6h23v1h-23zm0-6h23-23zm0-7h23v1h-23zm-38-10h38v54h-38z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M578 154h38v1h-38zm0-6h38v1h-38zm0-7h38v1h-38zm0-6h38v1h-38zm0-6h38v1h-38zm0-6h38-38zm0-7h38v1h-38z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M505 98h38v1h-38zm0-6h38-38zm0-7h38v1h-38zm0-6h38v1h-38z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M574 105h45v7h-45z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M617 105h28v7h-28z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M497 156h81v4h-81z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M387 0h43v24h-43z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M304 0h83v24h-83z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M295 16h95v144h-95z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M387 16h54v144h-54zm-92 36h92v4h-92zm0 33h92v4h-92zm0 34h92v4h-92z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M299 23h84v28h-84zm0 35h84v25h-84zm0 33h84v25h-84zm1 34h82v35h-82z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M355 18h3v33h-3zm-32 0h4v33h-4zm32 39h3v27h-3zm-32-1h4v28h-4zm32 34h3v27h-3zm-32 0h4v27h-4zm69 1h44v25h-44zm0-33h44v25h-44zm0-35h45v28h-45z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M326 160v-20h30v20"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M358 160h-4v-19h-27v19h-3v-22h34v22z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M477 143c-5-3-10 7-10 7s7-15 1-16c-3 0-5 6-7 13 0-6-1-11-3-11-6-1-3 15-3 15l2 9h10s14-14 10-17z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1004 149c-1-1-4-1-5 1a7 7 0 0 0-1 3c0-3-1-12-5-12-3 0-3 8-3 12-1-4-3-6-5-6-6 0 1 13 1 13h14l2-3a19 19 0 0 0 2-4 5 5 0 0 0 0-2 3 3 0 0 0 0-2z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1154 145h1a28 28 0 0 0 13 2c6 0 11-2 15-5 11-11-3-22-13-24-6-2-13-1-18 2s-8 9-6 15a15 15 0 0 0 8 10z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1157 122 1 1a19 19 0 0 0 10 1c4 0 8-1 10-4 8-9-2-18-9-20a14 14 0 0 0-13 2 13 13 0 0 0-5 12 13 13 0 0 0 6 8z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1165 123h1v37h-1z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66 137c-1-6-5-11-6-17-2-5-1-11-3-16a14 14 0 0 0-25 0c-3 5-2 11-3 16l-7 17a23 23 0 0 0 8 23h28a23 23 0 0 0 8-23z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45 113h1v47h-1z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M303 149c-1-1-4-1-5 1a7 7 0 0 0-1 3c0-3-1-12-5-12-3 0-3 8-3 12-2-4-3-6-5-6-6 0 1 13 1 13h14l2-3a19 19 0 0 0 2-4 5 5 0 0 0 0-2 3 3 0 0 0 0-2zm-219-6c-2-3-5-2-7 0a13 13 0 0 0-2 6c0-6 0-20-6-20-5 0-5 14-5 20-1-7-4-10-7-10-8 1 2 21 2 21h20l3-5a34 34 0 0 0 2-6 10 10 0 0 0 0-4 6 6 0 0 0 0-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterArt);
export default __webpack_public_path__ + "static/media/footer-art.3dc2e897450f51f87d253e045d72e4bf.svg";
export { ForwardRef as ReactComponent };